export const IS_TERMS = {
    notAccepted: 0,
    accepted: 1
}

export const CURRENCIES_KEYS_IDS = {
    1: 'UAH',
    2: 'USD',
    3: 'EUR'
}